





































import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'

// Components
import Box from '@/components/common/Box.vue'
import AvatarUploader from '@/components/images/AvatarUploader.vue'

// Views
import EditAccountProfile from '@/views/profile/forms/EditAccountProfile.vue'
import EditPasswordProfile from '@/views/profile/forms/EditPasswordProfile.vue'
import EditInformationsProfile from '@/views/profile/forms/EditInformationsProfile.vue'

@Component({
  components: {
    Box,
    EditPasswordProfile,
    EditAccountProfile,
    EditInformationsProfile,
    AvatarUploader
  }
})
export default class Profile extends Mixins(Errors) {
  avatarLoading: boolean = false
  reloadAvatar: boolean = false

  @Getter('profile', { namespace: 'user' }) user
  @Getter('locale', { namespace: 'user' }) locale
  @Getter('master', { namespace: 'user' }) isMaster
  @Getter('fullName', { namespace: 'user' }) userFullName
  @Action('destroyRegistration', { namespace: 'user' }) destroyRegistration
  @Action('updateAvatar', { namespace: 'user'}) updateAvatar

  @Getter('token') token

  @Meta
  metas() {
    return {
      title: this.$t('menu.profile'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  get role() {
    return this.isMaster ? this.$t('global.admin_label.admin') : this.$t('global.admin_label.member')
  }

  get zohoURL(): string {
    return process.env.VUE_APP_ZOHO_URL
  }

  get rgpdFormURL(): string {
    return this.locale === 'fr' ? process.env.VUE_APP_RGPD_FORM_FR_URL : process.env.VUE_APP_RGPD_FORM_EN_URL
  }

  async submitAvatar(base64) {
    try {
      this.avatarLoading = true
      const res = await this.updateAvatar(base64)
      this.reloadAvatar = true
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.avatarLoading = false
      setTimeout(() => {
        this.reloadAvatar = false
      }, 300)
    }
  }

  async logout() {
    await this.destroyRegistration()
    this.$router.push({
      name: 'login'
    })
    this.$toast.open({
      message: this.$t('logout.success.title') as string,
      type: 'is-success',
      duration: 5000
    })
  }
}
